import Vue from "vue";
import VueRouter from "vue-router";
// import HomeView from "../views/HomeView.vue";
import CryptoRankViewNew from "../views/CryptoRankViewNew.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: CryptoRankViewNew,
  },
  {
    path: "/admin",
    name: "admin",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Admin.vue"),
  },
  {
    path: "/wirex",
    name: "wirex",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/WirexView.vue"),
  },
  {
    path: "/crypto",
    name: "crypto",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CryptoViewNew.vue"),
  },
  {
    path: "/crypto-old",
    name: "crypto-old",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CryptoView.vue"),
  },
  {
    path: "/cryptorank-old",
    name: "cryptorank-old",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CryptoRankView.vue"),
  },
  {
    path: "/ccxt",
    name: "ccxt",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CCXTView.vue"),
  },
  {
    path: "/cryptorank",
    name: "cryptorank",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/CryptoRankViewNew.vue"),
  },
  {
    path: "/rates",
    name: "rates",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/HomeView.vue"),
  },
  {
    path: "/ex-rates",
    name: "exrates",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Rates.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
